// -- Imports -- //
require("onbrandutilityfunctions/build/conditional-babel-polyfill.bundle.js"); // use all the things!
// require("./onbrand.scss"); // Onbrand styles
// require("./client/client.scss"); // client styles
const onbrandUtilityFunctions = require("onbrandutilityfunctions");
const devOptions = require("./dev-options.js"); // Development options
const htmlHeader = require("./includes/header.html");
const htmlFooter = require("./includes/footer.html");
const hero = require("./custom-js/hero.js");
const tagging = require("./custom-js/tagging.js");
const ig = require("./custom-js/instagramLink.js");
const slicknav = require("./jquery.slicknav.min.js");

slicknav.slick();

// -- Startup -- //
const tagsMap = window.tagsMap;

if (!production) {
  onbrandUtilityFunctions.devMode(devOptions);
}
window.onbrandLoaded = false;
$("body").prepend(htmlHeader);
$("body").append(htmlFooter);

$("#mobile-nav").slicknav({
  label: "",
  duration: 500,
  duplicate: false,
  appendTo: "#mobile-menu",
  brand:
    ' <a href="https://www.nwea.org/"><img id="logo" class="img-responsive mobile restrict-height" src="//cdn.nwea.org/images/NWEA_logo.png" alt="NWEA" /></a>',
  closedSymbol: '<i class="fa fa-caret-down"></i>',
  // eslint-disable-next-line comma-dangle
  openedSymbol: '<i class="fa fa-caret-up"></i>'
});

// old time embed error throw "fix" (TODO: make this better)
onbrandUtilityFunctions.legacyEmbedTileFix();
// Remove the "touch" class on touchscreen laptops
onbrandUtilityFunctions.removeTouchForLaptops();
// Remove the hub function updateOverlaySize
onbrandUtilityFunctions.overrideHubFuctions();
// Adds body classes for content type (blogPost, youtube, sales-stream etc)
onbrandUtilityFunctions.helpfulClasses();
// Rebuild the share widget for the top-nav
onbrandUtilityFunctions.fixShareWidgetImproved();
// warns you if your query string is missing.
onbrandUtilityFunctions.noQueryStringSafeguard();
// makes the reco engine sticky to the target / top of screen
onbrandUtilityFunctions.recoEnginePositioning(".top-nav");
// Pre hub event hub events (Note: disabled by default)
// onbrandUtilityFunctions.legacyEvents();

// -- Custom Functions -- //
const stickyNav = () => {
  const injectedHeaderNav = $(".top-nav");
  if (
    $(window).scrollTop() >
    $("#injected-header").height() + $("#top-header").height()
  ) {
    injectedHeaderNav.addClass("fixed");
  } else {
    injectedHeaderNav.removeClass("fixed");
  }
};

const removeBanner = () => {
  if (
    $(window).scrollTop() >
      $(".large-header").height() + $("#injected-header").height() &&
    $("body").hasClass("single-page") === false
  ) {
    $("body").addClass("large-header-removed");
  }
};

const changeShareFlipbook = () => {
  const shareFlipbook = document.querySelector("ul.share-item.type-uberflip");
  if (shareFlipbook) {
    document.querySelector(
      "ul.share-item.type-uberflip>li:first-of-type"
    ).textContent = "Share this PDF";
  }
};

const footerEmailOnSubmit = () => {
  // eslint-disable-next-line arrow-parens
  const handleSubmit = e => {
    e.preventDefault();
    $("#mktoForm_1279").css("display", "none");
    $(".mkto-form-success.mkto-1279").css("display", "block");
  };

  $("#mktoForm_1279").on("submit", handleSubmit);
};

const clientSearch = () => {
  $(
    "#injected-header header.desktop form#search-utility label.fa.fa-search"
  ).on("click", function() {
    const searchText = $(this)
      .siblings('input[type="text"]:eq(0)')
      .val()
      .trim();
    if (searchText) {
      $(this)
        .parent("form")
        .submit();
    } else {
      $(this)
        .siblings('input[type="text"]:eq(0)')
        .focus();
    }
  });

  $("#injected-header header.desktop form#search-utility input#search-text").on(
    "keypress",
    // eslint-disable-next-line consistent-return
    function(e) {
      if (e.which == 13) {
        e.preventDefault();
        const searchText = $(this)
          .val()
          .trim();
        if (searchText) {
          $(this)
            .parent("form")
            .submit();
        } else {
          return false;
        }
      }
    }
  );
};

// -- Hub Events -- //
const onLoadAndPageChange = function() {
  onbrandUtilityFunctions.blockCtaFix();
  onbrandUtilityFunctions.fadeOutItem();
  // clientSearch();
  // changeShareFlipbook();
  // hero.updateBanner(window.customBanner);
  // tagging.tileLoop(tagsMap, tagging.addLabel);
  // ig.replaceGooglePlus();
  // footerEmailOnSubmit();
};

Hubs.Events.on("load", () => {
  if (!window.onbrandLoaded) {
    onLoadAndPageChange();

    // Add your onloads here...

    // end your onloads before here...
    window.onbrandLoaded = true;
  }
})
  .on("pageChange", () => {
    onLoadAndPageChange();
    $("body").removeClass("large-header-removed");
  })
  .on("itemsLoaded", (itemIds, selectors) => {
    // tagging.tileLoop(tagsMap, tagging.addLabel);
  })
  .on("resize", () => {
    onbrandUtilityFunctions.sideCtaFix();
    onbrandUtilityFunctions.addThisFix();
  })
  .on("scroll", () => {
    onbrandUtilityFunctions.sideCtaFix();
    onbrandUtilityFunctions.addThisFix();
    onbrandUtilityFunctions.blockCtaFix();
    onbrandUtilityFunctions.fadeOutItem();
    // stickyNav();
    // removeBanner();
  })
  // eslint-disable-next-line arrow-parens
  .on("ctaActivate", ctaId => {})
  .on("ctaFormSubmitSuccess", (ctaId, mappedData, ctaName) => {})
  .on("search", () => {});

// The new hub events can trigger before cihost scripts are loaded. This will ensure your scripts fire no matter what, but not more than once for 'load'.
if (!window.onbrandLoaded) {
  Hubs.Events.trigger("load");
}



// WEBPACK FOOTER //
// ./onbrand.js